import { tr } from "../../i18n";
import { useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout, { Field, ErrorNote, inputCls } from "./AuthLayout";
import { useAuth, api, apiError } from "../../auth/AuthContext";
export default function ChangePassword() {
  const {
    lang = "en"
  } = useParams();
  const navigate = useNavigate();
  const {
    user,
    refreshUser
  } = useAuth();
  const [form, setForm] = useState({
    current_password: "",
    new_password: "",
    confirm_password: ""
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  if (user === undefined) return null;
  if (!user) return <Navigate to={`/${lang}/login`} replace />;
  const forced = !!user.must_change_password;
  const submit = async e => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/change-password", form);
      await refreshUser();
      toast.success(tr("Password successfully updated."));
      navigate(`/${lang}/${user.role === "admin" ? "admin" : "portal"}`);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };
  return <AuthLayout title={tr("Change Password")} subtitle={forced ? undefined : "Update the password of your ESAIA account."}>
      {forced && <p className="mb-5 border border-amber-600/30 bg-amber-50 px-4 py-3 text-sm leading-relaxed text-amber-800" data-testid="forced-change-notice">{tr("For security reasons, you must create a new password before continuing.")}{" "}</p>}
      <form onSubmit={submit} className="space-y-5" data-testid="change-password-form">
        <ErrorNote error={error} />
        <Field label={tr("Current password")} required htmlFor="cp-current">
          <input id="cp-current" type="password" required value={form.current_password} onChange={e => setForm({
          ...form,
          current_password: e.target.value
        })} className={inputCls} data-testid="cp-current" autoComplete="current-password" />
        </Field>
        <Field label={tr("New password")} required htmlFor="cp-new">
          <input id="cp-new" type="password" required value={form.new_password} onChange={e => setForm({
          ...form,
          new_password: e.target.value
        })} className={inputCls} data-testid="cp-new" autoComplete="new-password" />
          <p className="mt-1 text-[11px] text-esaia-subtle">{tr("Minimum 8 characters, with a letter and a number.")}</p>
        </Field>
        <Field label={tr("Confirm new password")} required htmlFor="cp-confirm">
          <input id="cp-confirm" type="password" required value={form.confirm_password} onChange={e => setForm({
          ...form,
          confirm_password: e.target.value
        })} className={inputCls} data-testid="cp-confirm" autoComplete="new-password" />
        </Field>
        <button type="submit" disabled={loading} data-testid="cp-submit" className="w-full bg-esaia-blue px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-esaia-dark disabled:opacity-60">
          {loading ? tr("Updating...") : tr("Change Password")}
        </button>
      </form>
    </AuthLayout>;
}
